module.exports = __webpack_public_path__ + "img/antanta.b524d31e.jpg";